var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pitcrews-rewards-wrapper"},[_vm._v(" "+_vm._s(_vm.$t('pitCrewsRewards.text', { balance: _vm.rewardBalance }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }